import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
declare var echarts;//设置echarts全局对象
@Component({
  selector: 'app-mz-echarts-pie',
  templateUrl: './mz-echarts-pie.component.html',
  styleUrls: ['./mz-echarts-pie.component.scss']
})
export class MzEchartsPieComponent extends GridBaseCase {

  constructor() { super(); }

  @ViewChild('echartsContent') container: ElementRef;//与html中div #container1对应
  // @ViewChild('echartsContent2') container2: ElementRef;//与html中div #container1对应
  EChart: any;
  // echart2: any;
  ngOnInit() {
    const that = this;
    this.echartBind();
    window.addEventListener('resize',function(){
      that.EChart.resize();
    });
  }
  echartBind() {
    let ctelement = this.container.nativeElement;
    this.EChart = echarts.init(ctelement);
    let options = {
      backgroundColor: null,
      color: ['#0065bb', '#dfdfdf'],
      series: [{
        name: '新客',
        type: 'pie',
        radius: ['45%', '60%'],
        avoidLabelOverlap: false,
        hoverAnimation: false,
        label: {
          normal: {
            show: false,
            position: 'center',
            textStyle: {
              fontSize: 12,
              color: '#000000',
              fontWeight: 'bold'
            },
            formatter: function () {
              return 50 + "\n______\n100"
            }
          }
        },
        data: [{
          value: 50,
          name: '及格率',
          label: {
            normal: {
              show: true
            }
          }
        },
        {
          value: 100 - 50,
          name: ''
        }
        ]
      }]
    };
    this.EChart.setOption(options);
  }
  onResize() {
    this.EChart.resize();
  }

}
